module.exports = __webpack_public_path__ + "assets/img/logo202310.2bba7878.png";